<script setup lang="ts">
import { nb_no } from '@nuxt/ui/locale'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'

const previewMode = usePreviewMode()

const cart = useCartStore()

function refreshCart() {
  return cart.hydrateTempItems()
}

onMounted(refreshCart)

useEventListener(window, 'focus', refreshCart)

useScript({
  src: 'https://app.crystallize.com/static/frontend-preview-listener.js',
  defer: true,
}, {
  trigger: previewMode.enabled,
})

useHead({
  htmlAttrs: {
    lang: nb_no.code,
    dir: nb_no.dir,
    prefix: 'og: https://ogp.me/ns#',
    class: 'font-body bg-green-50',
  },
  bodyAttrs: {
    class: 'bg-beige-10',
  },
})

await useFallbackSeo()
</script>

<template>
  <UApp :locale="nb_no">
    <NuxtAnnouncer />
    <NuxtRouteAnnouncer />
    <NuxtLoadingIndicator
      color="repeating-linear-gradient(to right,var(--color-green-50) 0%,var(--color-green-30) 50%,var(--color-green-20) 100%)"
    />
    <LayoutSkipTo />
    <div class="grid min-h-screen grid-rows-[auto_1fr_auto] overflow-x-clip">
      <LayoutHeader />
      <NuxtPage />
      <LayoutFooter />
    </div>
    <VueQueryDevtools />
  </UApp>
</template>
